import { useHealth } from "../hooks/useHealth";

const THRESHOLD_GB = 5;

export function DiskLowBanner({ isAdmin }: { isAdmin: boolean }) {
  const q = useHealth(isAdmin);
  if (!isAdmin || !q.data) return null;
  if (q.data.disk_free_gb >= THRESHOLD_GB) return null;
  return (
    <div className="bg-amber-100 px-3 py-2 text-center text-xs font-medium text-amber-900">
      Levytila loppumassa: {q.data.disk_free_gb.toFixed(1)} GB jäljellä.
    </div>
  );
}
